import React, { useContext } from "react";
import { renderCount } from "../../../appHelpers/appLoggers";
import { DisplayMobileSidebarContext } from "../../../appContexts/DisplayMobileSidebarContext";
import styled from "styled-components";

export const MobileSidebarToggleFC = () => {
  // ENV CONDITIONALS
  const { REACT_APP_LOGGER_RENDER_COUNT } = process.env;
  REACT_APP_LOGGER_RENDER_COUNT === "TRUE" &&
    renderCount(`./components/main/header/MobileSidebarToggleFC`);

  const { displayMobileSidebar, setDisplayMobileSidebar } = useContext(
    DisplayMobileSidebarContext,
  );

  return (
    <HamburgerButton
      $isOpen={displayMobileSidebar}
      onClick={() => setDisplayMobileSidebar(!displayMobileSidebar)}
      aria-label="Toggle menu"
    >
      <HamburgerLine $isOpen={displayMobileSidebar} $position="top" />
      <HamburgerLine $isOpen={displayMobileSidebar} $position="middle" />
      <HamburgerLine $isOpen={displayMobileSidebar} $position="bottom" />
    </HamburgerButton>
  );
};

const HamburgerButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 44px;
  height: 44px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 10px;
  position: relative;
  z-index: 1001;

  @media screen and (min-width: 769px) {
    display: none;
  }
`;

const HamburgerLine = styled.span`
  width: 24px;
  height: 2px;
  background: #2c5aa0;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;

  ${({ $isOpen, $position }) => {
    if ($isOpen) {
      if ($position === "top") {
        return `
               transform: translateY(7px) rotate(45deg);
            `;
      } else if ($position === "middle") {
        return `
               opacity: 0;
               transform: translateX(-10px);
            `;
      } else if ($position === "bottom") {
        return `
               transform: translateY(-7px) rotate(-45deg);
            `;
      }
    }
    return "";
  }}
`;
